import { EmptyUUID } from './constants'

export function isEmptyUUID(input?: string | null): boolean {
  return !input || input === EmptyUUID
}
